import React from "react";

import { useTranslation } from "@litres-libs/i18n";

import { ContextMenuItem } from "@litres/ui-kit/context-menu";
import type { IMyBooksMenuProps } from "../../../utils/types";
import { useMyBooksMenuItems } from "../../../hooks/useMyBooksMenuItems";

export const MyBooksMenu = (props: IMyBooksMenuProps): JSX.Element => {
  const { t } = useTranslation();
  const { isLibrary } = props;
  const myBooksItems = useMyBooksMenuItems(isLibrary);

  return (
    <div data-testid="my-books__menu--desktop">
      {myBooksItems.map(({ title, href, isHasSticker, counter }) => (
        <ContextMenuItem
          key={title}
          asLink
          href={href}
          text={t(title)}
          counter={counter ?? undefined}
          hasBadge={isHasSticker}
          data-testid="headerDesktopMyBooksMenuItem"
        />
      ))}
    </div>
  );
};
